import React from 'react';

const MasterUDIDICode = ({
    AppContext,
    fieldTitle = "UDI-DI Code / (Master) UDI-DI Code",
    mandatory = false
}) => {

	return <>

		<div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <input type="text" className="form-control rounded-0 form-control-md" disabled title="You can edit this in the Product Details" value={AppContext.currentItem.UDIDI} />

                    {mandatory && !AppContext.currentItem.UDIDI && (
                        <span className="form-field-error-message">
                            {fieldTitle} is mandatory (set it in the Product Details)
                        </span>
                    )}

                </div>
            </div>
        </div>


		
	</>
}


export default MasterUDIDICode;
